module.exports = __webpack_public_path__ + "static/img/cupcakes.c8d4322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cupcakes.png
// module id = ZXXb
// module chunks = 0